import { render, staticRenderFns } from "./DebtorIpuTableWithFilter.vue?vue&type=template&id=4b4c38dd&"
import script from "./DebtorIpuTableWithFilter.vue?vue&type=script&lang=js&"
export * from "./DebtorIpuTableWithFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports